import { render, staticRenderFns } from "./CierreNovedadForm.vue?vue&type=template&id=3e8893b8"
import script from "./CierreNovedadForm.vue?vue&type=script&lang=js"
export * from "./CierreNovedadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports